import type { LandingLocale } from './landingContentTypes.js';
export const retailIndustryPageKeys = ['gastronomie', 'baecker', 'metzger', 'frischetheke'] as const;
export type RetailIndustryPageKey = (typeof retailIndustryPageKeys)[number];
export const isRetailIndustryPageKey = (key: string): key is RetailIndustryPageKey =>
  (retailIndustryPageKeys as readonly string[]).includes(key);
export const retailIndustryLabels: Record<LandingLocale, Record<RetailIndustryPageKey, readonly [string, string]>> = {
  de: {
    gastronomie: ['Gastronomie', 'Küche, Service und Gastfreundschaft'],
    baecker: ['Bäcker/in – Produktion und Verkauf', 'Backhandwerk, frische Backwaren und Beratung'],
    metzger: ['Metzger/in – Produktion, Verarbeitung und Verkauf', 'Fleischverarbeitung, Qualität und Fachverkauf'],
    frischetheke: ['Frischetheke: Käse, Fisch und Fleisch', 'Frische Produkte, Beratung und Kundenkontakt'],
  },
  en: {
    gastronomie: ['Gastronomy', 'Kitchen, service and hospitality'],
    baecker: ['Baker – production and sales', 'Baking, fresh goods and customer service'],
    metzger: ['Butcher – production, processing and sales', 'Meat processing, quality and specialist sales'],
    frischetheke: ['Fresh counter: cheese, fish and meat', 'Fresh products, advice and customer contact'],
  },
  tr: {
    gastronomie: ['Gastronomi', 'Mutfak, servis ve misafirperverlik'],
    baecker: ['Fırıncı – üretim ve satış', 'Fırıncılık, taze ürünler ve müşteri hizmetleri'],
    metzger: ['Kasap – üretim, işleme ve satış', 'Et işleme, kalite ve uzman satış'],
    frischetheke: ['Taze ürün tezgâhı: peynir, balık ve et', 'Taze ürünler, danışmanlık ve müşteri iletişimi'],
  },
};
